import { gql } from '@apollo/client';

export const GET_UPLOAD_FORM_DATA = gql`
  query GetUploadFormData($input: GetAssetUploadFormDataInput!) {
    getUploadFormData(input: $input)
  }
`;
